import $ from 'jquery';
import themeService     from 'ThemeService.js';
import util             from 'util/Util.js';
import eventBus         from 'EventBus.js';
import userService              from 'UserService';
import assetCollection from 'AssetCollection.js';
import { pickerCfg } from 'pickerCfg.js';
import pageSyncService  from 'PageSyncService.js';
import undoService from 'UndoService';
import focusController from 'FocusController';
import listService from 'ListService';

import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/theme/page.ejs';

class PageView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.model.set('pageBgColor', themeService.resolve('~pageBgColor'), {silent: true} );
        this.model.set('pageBgImage', themeService.resolve('~pageBgImage'), {silent: true} );

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change select' : 'updateSelectAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldValue = this.model.get('backgroundColor');
        const oldThemeValue = themeService._theme['~pageBgColor'];


        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal); 
            themeService._theme['~pageBgColor']= color;
            this.model.set('backgroundColor', color, {silent: true} );
            this.model.set('themePageColor', color, {silent: true} );

            this.render();

            $('#pageBgColor').val(color);
            $('#themePageColor').val(color);

            pageSyncService.renderCurrentPageView();
            this.addUndoRedoEvent(oldValue,oldThemeValue,color);

            //setTimeout( () => { eventBus.trigger('PageThemeChange'); }, 0);
            //setTimeout( () => { eventBus.trigger('outsideColorSet', color ); }, 0);
        } else {
            this.render();
        }
    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldValue = this.model.get('backgroundColor');
        const oldThemeValue = themeService._theme['~pageBgColor'];

        let color = this.resolveColor(propVal);
        themeService._theme['~pageBgColor']= color;
        this.model.set('backgroundColor', color, {silent: true} );
        this.model.set('themePageColor', color, {silent: true} );
        this.render();
        $('#pageBgColor').val(color);
        $('#themePageColor').val(color);

        pageSyncService.renderCurrentPageView();
        this.addUndoRedoEvent(oldValue,oldThemeValue,color);
    }

    addUndoRedoEvent(oldValue,oldThemeValue,newColorValue){
        undoService.add({
            undo:() => {
                this.model.set('backgroundColor', oldValue, {silent: true} );
                this.model.set('themePageColor', oldValue, {silent: true} );
                themeService._theme['~pageBgColor']= oldThemeValue;
                this.render();
                $('#pageBgColor').val(oldValue);
                $('#themePageColor').val(oldValue);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                // PF-2041 No one listen for this event. Commenting it out in case that is needed.
                //eventBus.trigger('PageThemeChange');
            },
            redo: () => {
                this.model.set('backgroundColor', newColorValue, {silent: true} );
                this.model.set('themePageColor', newColorValue, {silent: true} );
                themeService._theme['~pageBgColor']= newColorValue;
                this.render();
                $('#pageBgColor').val(newColorValue);
                $('#themePageColor').val(newColorValue);
                pageSyncService.renderCurrentPageView();
                focusController.switchPropsViews();
                // PF-2041 No one listen for this event. Commenting it out in case that is needed.
                //eventBus.trigger('PageThemeChange');
            }
        })
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropValue=this.model.get(propName);
            
        this.model.set( propName, propVal, {silent: true} );
        themeService._theme['~'+propName] = propVal;
        this.render();
        $('#pageBgColor').val(this.model.get('backgroundColor'));
        $('#themePageColor').val(this.model.get('backgroundColor'));
        pageSyncService.renderCurrentPageView();
          undoService.add({
            undo:() => {
              this.model.set( propName, oldPropValue, {silent: true} );
              themeService._theme['~'+propName] = oldPropValue;
              pageSyncService.renderCurrentPageView();
              focusController.switchPropsViews();
                // PF-2041 No one listen for this event. Commenting it out in case that is needed.
              //eventBus.trigger('PageThemeChange');
            },
            redo: () => {
              this.model.set( propName, propVal, {silent: true} );
              themeService._theme['~'+propName] = propVal;
              pageSyncService.renderCurrentPageView();
              focusController.switchPropsViews();
                // PF-2041 No one listen for this event. Commenting it out in case that is needed.
              //eventBus.trigger('PageThemeChange');
            }
          })
    }

    render() {
        super.render();
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        assetCollection.forEach( asset  => {
            var opt = document.createElement('option');
            opt.text = asset.get('name');
            opt.value = asset.get('id');

            $('#pageBgImage').append(opt);

        });

        if (this.model.get('pageBgImage')) {
            $('#pageBgImage').find('option[value='+this.model.get('pageBgImage')+']').attr('selected', true);
        }

        const validatEvent = (ev) => {
            return ev.target && ev.target.classList.contains('ui-resizable-handle');
        }

       /* document.addEventListener('mousedown', function(ev) {

            if (validatEvent(ev) && !listService.isMouseDown) {
                console.warn("mouse down....", ev);
                listService.isHandleInsideGroup = false;
                listService.isMouseDown = true;
            }
        }, true);

        document.addEventListener('mousemove', function(ev) {
            if (validatEvent(ev) && listService.isMouseDown) {
                console.warn("mouse move....", ev);
                listService.isHandleInsideGroup = true;
            }
        }, true);

        document.addEventListener('mouseup', function(ev) {
            if (validatEvent(ev) && listService.isMouseDown) {
                console.warn("mouse up....", ev);
                listService.isHandleInsideGroup = false;
                listService.isMouseDown = false;
            }
        }, true);*/


        this.delegateEvents();
        return this;
    }
}

export default PageView;
